module.exports = __webpack_public_path__ + "static/media/energy4.50048908.jpg";